import React from 'react';
import './Footer.css';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../Logo/Logo';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaChevronRight } from 'react-icons/fa';

const Footer = () => {
	const navigate = useNavigate();
	const goTo = (path) => (e) => {
		e.preventDefault();
		navigate(path);
		window.scrollTo(0, 0);
	};
	return (
		<footer className="footer">
			<div className="footer-top">
				<div className="container">
					<div className="row g-4">
						<div className="col-12 col-sm-6 col-lg-3">
							<div className="footer-widget footer-about">
								<div className="footer-logo">
									<Link to="/">
										<Logo height={52} color="#fff" />
									</Link>
								</div>
								<p className="footer-about__text">
									Quality healthcare connections with a personal touch. Serving patients across Zimbabwe.
								</p>
							</div>
						</div>
						<div className="col-12 col-sm-6 col-lg-3">
							<div className="footer-widget footer-menu">
								<h3 className="footer-title">For patients</h3>
								<ul className="footer-list">
									<li><a href="/doctors" onClick={goTo('/doctors')}><FaChevronRight className="footer-list__icon" /> Find a doctor</a></li>
									<li><a href="/doctors" onClick={goTo('/doctors')}><FaChevronRight className="footer-list__icon" /> Book appointment</a></li>
									<li><a href="/track-appointment" onClick={goTo('/track-appointment')}><FaChevronRight className="footer-list__icon" /> Track appointment</a></li>
									<li><a href="/login" onClick={goTo('/login')}><FaChevronRight className="footer-list__icon" /> Login</a></li>
									<li><a href="/login" onClick={goTo('/login')}><FaChevronRight className="footer-list__icon" /> Register</a></li>
								</ul>
							</div>
						</div>
						<div className="col-12 col-sm-6 col-lg-3">
							<div className="footer-widget footer-menu">
								<h3 className="footer-title">For doctors</h3>
								<ul className="footer-list">
									<li><a href="/dashboard/appointments" onClick={goTo('/dashboard/appointments')}><FaChevronRight className="footer-list__icon" /> Appointments</a></li>
									<li><a href="/login" onClick={goTo('/login')}><FaChevronRight className="footer-list__icon" /> Login</a></li>
									<li><a href="/dashboard/schedule" onClick={goTo('/dashboard/schedule')}><FaChevronRight className="footer-list__icon" /> Schedule</a></li>
								</ul>
							</div>
						</div>
						<div className="col-12 col-sm-6 col-lg-3">
							<div className="footer-widget footer-contact">
								<h3 className="footer-title">Contact us</h3>
								<div className="footer-contact__item">
									<FaMapMarkerAlt className="footer-contact__icon" />
									<p>12 Kianga, 146 Baines Avenue,<br />Harare, Zimbabwe</p>
								</div>
								<div className="footer-contact__item">
									<FaPhoneAlt className="footer-contact__icon" />
									<p><a href="tel:+263779484938">+263 779 484 938</a></p>
								</div>
								<div className="footer-contact__item">
									<FaEnvelope className="footer-contact__icon" />
									<p><a href="mailto:support@specialisthub.co.zw">support@specialisthub.co.zw</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="footer-bottom">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-12 col-md-6 text-center text-md-start">
							<p className="footer-copyright">
								&copy; 2025 SpecialistHub. All rights reserved.
							</p>
						</div>
						<div className="col-12 col-md-6">
							<ul className="footer-policy">
								<li><Link to="/terms">Terms & conditions</Link></li>
								<li><Link to="/policy">Privacy policy</Link></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
